import React, { useEffect, useState } from 'react';
import axiosInstance from './tmdb';  // Asegúrate de tener configurada la instancia de axios
import './App.css';

function App() {
  const [movies, setMovies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    axiosInstance.get('/movie/popular')
      .then(response => {
        setMovies(response.data.results);
        setLoading(false);
      })
      .catch(error => {
        setError('Error al cargar las películas');
        setLoading(false);
      });
  }, []);

  return (
    <div className="container">
      <header>
        <h1>Películas Populares</h1>
        <p>Explora las películas más populares del momento</p>
      </header>

      {loading ? (
        <div className="loading">Cargando...</div>
      ) : error ? (
        <div className="error">{error}</div>
      ) : (
        <div className="movies-list">
          {movies.map(movie => (
            <div key={movie.id} className="movie-card">
              <img src={`https://image.tmdb.org/t/p/w500${movie.poster_path}`} alt={movie.title} />
              <h3>{movie.title}</h3>
              <p>{movie.overview}</p>
              <a href={`https://www.themoviedb.org/movie/${movie.id}`} target="_blank" rel="noopener noreferrer">Ver Más</a>
            </div>
          ))}
        </div>
      )}

      {/* Footer */}
      <footer className="footer">
        <div className="footer-content">
          <p>&#169; Copyright exe.dnl 2024</p>
          <p className="api-rights">
            Datos proporcionados por <a href="https://www.themoviedb.org/documentation/api" target="_blank" rel="noopener noreferrer">The Movie Database (TMDb)</a>.
          </p>
        </div>
      </footer>
    </div>
  );
}

export default App;
